import { darkTheme, lightTheme, Theme } from '../../theme';
import { ReactElement, useEffect, useState } from 'react';
import { Wrapper } from './ThemeChanger.elements';
import { IoMoonOutline, IoSunnyOutline } from 'react-icons/io5';

type ThemeChangerProps = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const ThemeChanger = ({
  theme,
  setTheme,
}: ThemeChangerProps): ReactElement => {
  const [icon, setIcon] = useState(<IoSunnyOutline />);

  useEffect(() => {
    switch (theme.name) {
      case 'light':
        setIcon(<IoMoonOutline />);
        return;
      case 'dark':
        setIcon(<IoSunnyOutline />);
        return;
    }
  }, [theme]);

  const switchTheme = () => {
    if (theme.name === 'light') {
      setTheme(darkTheme);
    } else {
      setTheme(lightTheme);
    }
  };

  return <Wrapper onClick={switchTheme}>{icon}</Wrapper>;
};
